import styled from 'styled-components';
import { sharedStyles } from './sharedStyles';
export var Verified = styled.div.withConfig({
  displayName: "Verified",
  componentId: "sc-3om3on-0"
})(["", ";border-radius:", "px;background-color:", ";color:", ";svg{position:absolute;top:", "px;left:", "px;}"], sharedStyles, function (_ref) {
  var size = _ref.size;
  return size;
}, function (_ref2) {
  var theme = _ref2.theme,
    inverted = _ref2.inverted;
  return inverted ? '#fff' : theme.verifiedColor;
}, function (_ref3) {
  var theme = _ref3.theme,
    inverted = _ref3.inverted;
  return inverted ? theme.verifiedColor : '#fff';
}, function (_ref4) {
  var size = _ref4.size,
    iconSize = _ref4.iconSize;
  return (size - iconSize) / 2;
}, function (_ref5) {
  var size = _ref5.size,
    iconSize = _ref5.iconSize;
  return (size - iconSize) / 2;
});